import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { getLocale } from 'lib/utils/getLocale'

import Link from 'components/Link'
import ErrorMessageContent from 'components/Errors/Messages/ErrorMessageContent'

const UnverifiedVehicleErrorMessage = () => {
    const { i18n } = useTranslation(['errors'])

    return (
        <ErrorMessageContent
            content={(
                <p>
                    <Trans i18nKey="errors:omanettix.10112.message">
                        Creating a bill of sale is only possible for Verified ads.
                        <Link to={`${getLocale(i18n.language)}/fiksut-kaupat`} trackName="moreAboutVerifiedAd">Instructions for creating verified ad</Link>
                    </Trans>
                </p>
            )}
        />
    )
}

export default UnverifiedVehicleErrorMessage
